/**
 * Practitioner route group layout
 *
 * Stack navigator for the Practitioner Portal. Entered from Settings when
 * a user with isPractitioner === true taps "Open Practitioner Dashboard".
 * Back navigation returns to the consumer Settings tab.
 *
 * Header displays a "Practitioner Mode" indicator so the user always knows
 * they are inside the professional portal.
 */
import { Stack } from 'expo-router';
import { View, Text, StyleSheet } from 'react-native';

function PractitionerModeHeaderTitle() {
  return (
    <View style={styles.headerTitle}>
      <View style={styles.dot} />
      <Text style={styles.headerText}>Practitioner Mode</Text>
    </View>
  );
}

export default function PractitionerLayout() {
  return (
    <Stack
      screenOptions={{
        headerTitle: () => <PractitionerModeHeaderTitle />,
        headerBackTitle: 'Settings',
        headerStyle: styles.header,
        headerTintColor: '#7c3aed',
      }}
    />
  );
}

const styles = StyleSheet.create({
  header: {
    backgroundColor: '#fdf4ff',
  },
  headerTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#A78BFA',
  },
  headerText: {
    fontSize: 16,
    fontWeight: '700',
    color: '#7c3aed',
  },
});
